import { PagingResultsViewModel, EnumSiNoTodos, FilterSearchingBaseViewModel } from '../../../core/_infrastructure/types/common';

export class PuntoControlItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: PuntoControlViewModel[];
}

export class PuntoControlViewModel {
    constructor() {}

    public Id: number;
    public Descripcion: string = '';
    public IdPais: number = 0;
    public IdPaisDescripcion: string = '';
    public IdentificadorTraces: string = '';
    public Direccion: string = '';
    public Localidad: string = '';
    public CodigoZip: string = '';
    public Activo: boolean = true;
    public TwAutoridadControlCollection: AutoridadControlViewModel[];
}

export class FilterSearchingPuntoControlViewModel extends FilterSearchingBaseViewModel {
    public Descripcion: string = '';
    public IdPais: number | null = null;
    public IdentificadorTraces: string = '';
    public Direccion: string = '';
    public Localidad: string = '';
    public CodigoZip: string = '';
    public Activo: number = EnumSiNoTodos.TODOS;
}

export class AutoridadControlViewModel {
    public Id: number = 0;
    public IdPuntoControl: number;
    public Descripcion: string = '';
    public ReferenciaTraces: string = '';
    public Direccion: string = '';
    public CodigoPostal: string = '';
    public Ciudad: string = '';
    public Activa: boolean = true;
    public DescripcionConRefTraces: string = '';
}
